import { rfidValidate } from 'services/payments-service';

/**
 * async validate
 * @param {*} values
 * @returns
 */
export const asyncValidate = (data) => {
  if (window.rfidFormEdit) {
    return Promise.resolve();
  }

  return rfidValidate(data);
};
